// extracted by mini-css-extract-plugin
export var buttonWithDividerContainer = "custom-form-module--button-with-divider-container--b69f6";
export var candidateInput = "custom-form-module--candidate-input--db4af";
export var candidateList = "custom-form-module--candidate-list--26803";
export var divider = "custom-form-module--divider--5977e";
export var dividerButton = "custom-form-module--divider-button--bdf75";
export var dividerButtonIcon = "custom-form-module--divider-button-icon--6b640";
export var dividerButtonWrapper = "custom-form-module--divider-button-wrapper--6b01e";
export var dividerWrapper = "custom-form-module--divider-wrapper--5a339";
export var downloadFormField = "custom-form-module--download-form-field--6381a";
export var downloadFormFieldCheckbox = "custom-form-module--download-form-field-checkbox--7aa19";
export var downloadFormFieldCheckboxLabel = "custom-form-module--download-form-field-checkbox-label--abcf3";
export var downloadFormFieldLabel = "custom-form-module--download-form-field-label--e8618";
export var downloadFormFieldWrapper = "custom-form-module--download-form-field-wrapper--09598";
export var downloadFormRow = "custom-form-module--download-form-row--46a21";
export var formCheckbox = "custom-form-module--form-checkbox--63b02";
export var formField = "custom-form-module--form-field--d3d78";
export var formGroup = "custom-form-module--form-group--bd222";
export var formRow = "custom-form-module--form-row--a8293";
export var formSubmit = "custom-form-module--form-submit--11358";
export var loadingSpinner = "custom-form-module--loading-spinner--17c86";
export var modalAccept = "custom-form-module--modal-accept--c2068";
export var modalCancel = "custom-form-module--modal-cancel--e198c";
export var modalCheckout = "custom-form-module--modal-checkout--c9df7";
export var modalCheckoutItem = "custom-form-module--modal-checkout-item--af9cf";
export var modalFooter = "custom-form-module--modal-footer--df694";
export var rotateSpinner = "custom-form-module--rotateSpinner--cf9cd";
export var subtitle = "custom-form-module--subtitle--7bd65";
export var thankYouMessage = "custom-form-module--thankYouMessage--2aa3c";